import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single, _WorkActivitySubtask } from "../../../../core/services/dataBean/EntityCatalog";
import { useEffect } from "react";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectWorkActivityGroup } from "../../WorkActivityGroup/SelectWorkActivityGroup";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";

type WorkgroupActivity = {
    IDWorkActivity: number;
    [key: string]: any;
}

interface Props {
    WorkActivity: WorkgroupActivity;
}

export const WorkActivitySubtask = ({ WorkActivity }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivitySubtask);
    // const paginador = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar sub-tarea", MODAL_SM);

    useEffect(() => {
        if (WorkActivity.IDWorkActivity) {
            getLista();
        }
    }, [WorkActivity])

    const getLista = () => {
        const props = {
            IDWorkActivity: WorkActivity.IDWorkActivity,
            State: 1
        }
        instance.getWorkActivitySubtaskCatalogPorPropiedades(props, null).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivitySubtask', visible: true },
        { title: 'Sub-Tarea', property: 'Name', visible: true },
        { title: 'Descripción de la Sub-Tarea', property: 'Description', visible: true },
        { title: '¿Completada?', property: 'IsCompleted', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
    ];

    const create = () => {
        setBean({
            State: 1,
            IDWorkActivity: WorkActivity.IDWorkActivity,
            IsCompleted: false,
        });
        modal.open("Agregar sub-tarea")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { modal.open(`Editar Sub-tarea`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateWorkActivitySubtask(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="¿Esta Completada?" estado={bean.IsCompleted} eventChange={(e) => { setBean({ ...bean, IsCompleted: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar sub Tarea {bean.Name}</strong>
                </ModalConfirm>

            </div>
        </div>
    )
}